var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12.205 11.35a1.77 1.77 0 0 1-1.41 0l-8.55-3.96a.84.84 0 0 1 0-1.5l8.55-3.99a1.77 1.77 0 0 1 1.41 0l8.55 3.96a.84.84 0 0 1 0 1.5zm9.045.675L12.1 16.24a1.5 1.5 0 0 1-1.245 0L1.75 12.025m19.5 4.875-9.15 4.215a1.5 1.5 0 0 1-1.245 0L1.75 16.9"
})));
export default SvgLayers;